<template>
  <div class="edit-order-dialog">
    <el-dialog
      title="编辑员工保信息"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
      class="edit-order-main-dialog">
      
      <el-tabs v-model="activeTab" type="card">
        <!-- 编辑标签页 -->
        <el-tab-pane label="编辑" name="edit">
          <div class="edit-section">
            <el-form label-width="120px">
              <div class="order-info">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="投保人：">
                      <el-input v-model="orderInfo.policyholder" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="渠道：">
                      <el-input v-model="orderInfo.policy_channel" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            
            <div class="employee-table">
              <h3>员工信息</h3>
              <el-table :data="employees" border style="width: 100%">
                <el-table-column prop="name" label="姓名" width="120">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.name" 
                  size="small"
                  disabled
                  :style="{ color: scope.row.is_highlight ? 'red' : '#000' }"
                  :title="scope.row.is_highlight ? '该名员工的年龄不符合要求，请尽快处理' : ''"
                />
              </template>
            </el-table-column>
            <el-table-column prop="idcard" label="身份证号" width="180">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.idcard" 
                  disabled
                  size="small"
                  :style="{ color: scope.row.is_highlight ? 'red' : '#000' }"
                  :title="scope.row.is_highlight ? '该名员工的年龄不符合要求，请尽快处理' : ''"
                />
              </template>
            </el-table-column>
            <el-table-column prop="type" label="工作类型" min-width="200">
              <template slot-scope="scope">
                <el-radio-group v-model="scope.row.type" disabled size="small">
                  <el-radio :label="1">搬运工人</el-radio>
                  <el-radio :label="2">文员内勤</el-radio>
                  <el-radio :label="4">司机押运</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
              </el-table>
            </div>
            
            <div class="action-buttons">
              <el-button type="primary" @click="saveEmployees" :loading="saveLoading">保存</el-button>
              <el-button @click="handleClose">取消</el-button>
            </div>
            </el-form>
          </div>
        </el-tab-pane>
        
        <!-- 加人标签页 -->
        <el-tab-pane label="加人" name="add">
          <div class="add-section">
            <!-- 上传员工信息 -->
            <div class="upload-section">
              <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :headers="computedUploadHeaders"
                :on-success="handleUploadSuccess"
                :before-upload="beforeUpload"
                accept=".xls,.xlsx"
                name="fileVal"
                style="display: inline-block;">
                <el-button size="small" type="primary">上传员工信息</el-button>
              </el-upload>
              <div class="upload-tips">
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
                <div class="template-download">
                  <a href="https://api.rbbaotong.com/v1/hyx/static/%E6%96%B0%E7%89%88%E5%91%98%E5%B7%A5%E4%BF%9D%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xls" target="_blank" style="color: brown;">下载员工信息模板</a>
                </div>
              </div>
            </div>
            
            <!-- 加保员工信息表格 -->
            <div class="add-employee-table">
              <h3>加保员工信息</h3>
              <el-table :data="addEmployees" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="name" label="姓名" width="120">
                  <template slot-scope="scope">
                    <el-input 
                      v-model="scope.row.name" 
                      size="small"
                      placeholder="请输入姓名"
                      @blur="validateEmployee(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="idcard" label="身份证号" width="200">
                  <template slot-scope="scope">
                    <el-input 
                      v-model="scope.row.idcard" 
                      size="small"
                      placeholder="请输入身份证号"
                      @blur="validateEmployee(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="工作类型" width="300">
                  <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.type" size="small" @change="calculatePremium">
                      <el-radio :label="1">搬运工人</el-radio>
                      <el-radio :label="4">司机押运</el-radio>
                      <el-radio :label="2">文员内勤</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column prop="add_price" label="参考保费(元)" width="120">
                  <template slot-scope="scope">
                    <el-input 
                      v-model="scope.row.add_price" 
                      size="small"
                      placeholder="请输入保费"
                      @blur="calculatePremium"
                      style="text-align: center;"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button 
                      type="text" 
                      size="small" 
                      style="color: #f56c6c;"
                      @click="removeAddEmployee(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              
              <div class="table-actions">
                <el-button type="text" style="color: #f56c6c;" @click="addEmployee">新增</el-button>
              </div>
            </div>
            
            <!-- 保费信息区域 -->
            <el-form label-width="150px">
              <div class="premium-section">
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="生效时间：">
                      <el-date-picker
                        v-model="effectDate"
                        type="date"
                        placeholder="请选择生效时间"
                        style="width: 170px;"
                        :editable="false"
                        value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="加保总保费(元)：">
                      <el-input v-model="addPrice" readonly style="width: 100px;"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="挂账保费(元)：">
                      <el-input v-model="creditAmount" readonly style="width: 100px;"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="支付方式：">
                      <el-radio-group v-model="payType" :disabled="isPayTypeDisabled">
                        <el-radio :label="1">对公支付</el-radio>
                        <el-radio :label="2">二维码</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="本次需支付保费(元)：">
                      <el-input v-model="payableAmount" readonly style="width: 150px;"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
            
            <!-- 计算参考保费按钮 -->
            <div class="calculate-section">
              <el-button 
                type="primary" 
                @click="calculateReferencePremium"
                style="margin-left: 120px; margin-top: 20px;">
                计算参考保费
              </el-button>
            </div>
            
            <!-- 参考保费表格 -->
            <div class="reference-premium-table" style="margin-left: 120px; margin-top: 20px;">
              <table border="1" style="border-collapse: collapse;">
                <tr>
                  <td width="80" style="text-align: center; padding: 8px; background: #f5f5f5;">工作类型</td>
                  <td width="120" style="text-align: center; padding: 8px; background: #f5f5f5;">参考保费(元)</td>
                </tr>
                <tr>
                  <td width="80" style="text-align: center; padding: 8px;">搬运工人</td>
                  <td width="120" style="text-align: center; padding: 8px;">{{ dPrice || '' }}</td>
                </tr>
                <tr>
                  <td width="80" style="text-align: center; padding: 8px;">司机押运</td>
                  <td width="120" style="text-align: center; padding: 8px;">{{ tPrice || '' }}</td>
                </tr>
                <tr>
                  <td width="80" style="text-align: center; padding: 8px;">文员内勤</td>
                  <td width="120" style="text-align: center; padding: 8px;">{{ cPrice || '' }}</td>
                </tr>
              </table>
            </div>
            
            <!-- 文件上传区域 -->
            <div class="file-upload-section" style="position: relative; margin-top: 20px;">
              <div style="margin-left: 120px;">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="computedUploadHeaders"
                  :on-success="handleCorrectUploadSuccess"
                  :file-list="correctFiles"
                  list-type="picture"
                  name="fileVal"
                  style="display: inline-block;">
                  <el-button size="small" type="primary">上传批改申请</el-button>
                </el-upload>
                
              </div>
            </div>
            
            <div class="file-upload-section" v-if="payType === 1" style="position: relative; margin-top: 20px;">
              <div style="margin-left: 120px;">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="computedUploadHeaders"
                  :on-success="handlePaymentUploadSuccess"
                  :file-list="paymentFiles"
                  list-type="picture"
                  name="fileVal"
                  style="display: inline-block;">
                  <el-button size="small" type="primary">上传支付凭证</el-button>
                </el-upload>
              </div>
            </div>
            
            <!-- 提交按钮 -->
            <div class="submit-section" style="padding: 50px 0; text-align: center;">
              <el-button 
                type="primary" 
                @click="submitAddEmployees(1)" 
                :loading="submitLoading"
                :disabled="!btnDisabled"
                style="width: 158px; height: 39px;">
                {{ btnDisabled ? '暂存' : '暂存中' }}
              </el-button>
              <el-button 
                type="primary" 
                @click="submitAddEmployees(2)" 
                :loading="submitLoading"
                :disabled="!btnDisabled"
                style="width: 158px; height: 39px; margin-left: 20px;">
                {{ btnDisabled ? '保存' : '保存中' }}
              </el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="换人" name="substitute" :disabled="!allowSubstitute">
          <Substitute
            v-if="activeTab === 'substitute'"
            :visible="dialogVisible"
            :embedded="true"
            :row-data="currentRow"
            @success="handleSubstituteSuccess"
            @cancel="handleSubstituteCancel"
          />
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { ygbOrderInfo, ygbOrderEmployeeList, ygbOrderEditEmployee, ygbOrderAddEmployee, ygbOrderAddPerPrice, ygbOrderAddEmployeeTemp } from '@/api/member.js'
import Substitute from './Substitute.vue'

export default {
  name: 'EditOrder',
  components: {
    Substitute
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentRow: {
      type: Object,
      default: () => ({})
    },
    allowSubstitute: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      activeTab: 'edit',
      loading: false,
      saveLoading: false,
      submitLoading: false,
      btnDisabled: true,
      
      // 订单信息
      orderInfo: {
        id: '',
        product_name: '',
        policyholder: '',
        policy_channel: ''
      },
      
      // 编辑相关
      employees: [],
      
      // 加保相关
      addEmployees: [{
        name: '',
        idcard: '',
        type: 1,
        add_price: 0
      }],
      effectDate: '',
      addPrice: 0,
      payableAmount: 0,
      creditAmount: 0,
      payType: 1,
      isPayTypeDisabled: false,
      
      // 价格信息
      dPrice: 0,
      tPrice: 0,
      cPrice: 0,
      defaultType: 1,
      
      // 文件上传
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || process.env.VUE_APP_BASE_URL + '/res/file/upload',
      uploadHeaders: {},
      paymentFiles: [],
      correctFiles: [],
      paymentReceiptsUrl: [],
      correctUrl: [],
      
      // 年龄限制
      ageList: []
    }
  },
  computed: {
    computedUploadHeaders() {
      return {
        'Authorization': 'Bearer ' + (this.$store?.getters?.token || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    async initData() {
      if (!this.currentRow || !this.currentRow.id) return
      
      this.loading = true
      try {
        // 获取订单信息
        await this.getOrderInfo()
        // 获取员工列表
        await this.getEmployeeList()
        // 设置默认值
        this.setDefaults()
      } catch (error) {
        console.error('初始化数据失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    
    async getOrderInfo() {
      const response = await ygbOrderInfo({
        id: this.currentRow.id,
        platform_type: 8
      })
      
      if (response && response.err_code === 0) {
        const order = response.order
        this.orderInfo = {
          id: order.id,
          product_name: order.product_name,
          policyholder: order.company_name,
          policy_channel: order.policy_channel
        }
        
        this.creditAmount = order.credit_amount / 100
        // this.dPrice = order.driver_price
        // this.tPrice = order.trucker_price
        // this.cPrice = order.clerk_price
        
        // 设置默认工作类型
        this.defaultType = this.dPrice ? 1 : this.tPrice ? 4 : 2
        this.addEmployees[0].type = this.defaultType
        
        // 设置支付方式
        const payType = JSON.parse(order.pay_type)
        this.isPayTypeDisabled = payType.length === 1
        this.payType = payType[0]
        
        // 获取年龄限制
        await this.getAgeList()
      }
    },
    
    async getEmployeeList() {
      const response = await ygbOrderEmployeeList({
        order_id: this.currentRow.id
      })
      
      if (response && response.err_code === 0) {
        this.employees = response.rows.map(emp => ({
          id: emp.id,
          name: emp.name,
          idcard: emp.idcard,
          type: emp.type,
          status: emp.status,
          is_highlight: emp.is_highlight
        }))
      }
    },
    
    async getAgeList() {
      // 这里应该调用获取年龄限制的API
      // 暂时使用空数组
      this.ageList = []
    },
    
    setDefaults() {
      // 设置默认生效日期为明天
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      this.effectDate = tomorrow
    },
    
    getStatusType(status) {
      const statusMap = {
        1: 'success',    // 已生效
        2: 'warning',    // 未生效
        4: 'danger',     // 已删除
        8: 'warning',    // 出险锁定状态
        16: 'info'       // 已过期
      }
      return statusMap[status] || 'info'
    },
    
    getStatusText(status) {
      const statusMap = {
        1: '已生效',
        2: '未生效', 
        4: '已删除',
        8: '出险锁定状态',
        16: '已过期'
      }
      return statusMap[status] || '未知状态'
    },
    
    getWorkTypeText(type) {
      const typeMap = {
        1: '搬运工人',
        2: '文员内勤',
        4: '司机',
        default: '未知'
      }
      return typeMap[type] || typeMap.default
    },
    
    removeEmployee(index) {
      if (this.employees[index].status !== 16) {
        this.employees[index].status = 16
      }
    },
    
    async saveEmployees() {
      try {
        this.saveLoading = true
        
        // 验证员工信息
        if (!this.checkEmployeeInfo()) {
          this.saveLoading = false
          return
        }
        
        // 过滤掉已过期的员工（status != 16）
        const validEmployees = this.employees.filter(emp => emp.status !== 16)
        
        const response = await ygbOrderEditEmployee({
          order_id: this.currentRow.id,
          employee_list: validEmployees
        })
        
        if (response && response.err_code === 0) {
          this.$message.success('保存成功')
          this.handleClose()
          this.$emit('success')
        } else if (response && response.err_code === 203) {
          this.$message.error(response.err_msg)
        } else {
          this.$message.error(response.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存员工信息失败:', error)
        this.$message.error('保存失败，请重试')
      } finally {
        this.saveLoading = false
      }
    },
    
    checkEmployeeInfo() {
      for (let i = 0; i < this.employees.length; i++) {
        const emp = this.employees[i]
        if (!emp.name || !emp.name.trim()) {
          this.$message.error('请完善人员姓名')
          return false
        }
        if (!emp.idcard || !emp.idcard.trim()) {
          this.$message.error('请完善人员身份证号')
          return false
        }
        // 去除空格
        emp.name = emp.name.trim()
        emp.idcard = emp.idcard.trim()
      }
      return true
    },
    
    addEmployee() {
      this.addEmployees.push({
        name: '',
        idcard: '',
        type: this.defaultType,
        add_price: 0
      })
    },
    
    removeAddEmployee(index) {
      if (this.addEmployees.length === 1) {
        this.$message.warning('加保人员最少为1名')
        return
      }
      this.addEmployees.splice(index, 1)
      this.calculatePremium()
    },
    
    async calculatePremium() {
      if (!this.effectDate) return
      
      try {
        const response = await ygbOrderAddPerPrice({
          order_id: this.currentRow.id,
          effect_date: this.formatDate(this.effectDate)
        })
        
        if (response && response.err_code === 0) {
          this.cPrice = response.data.cPrice / 10000
          this.dPrice = response.data.dPrice / 10000
          this.tPrice = response.data.tPrice / 10000
          
          // 计算每个员工的保费
          this.addEmployees.forEach(emp => {
            switch (emp.type) {
              case 1: // 搬运工人
                emp.add_price = this.dPrice
                break
              case 2: // 文员内勤
                emp.add_price = this.cPrice
                break
              case 4: // 司机
                emp.add_price = this.tPrice
                break
            }
          })
          
          // 计算总保费
          this.addPrice = this.addEmployees.reduce((total, emp) => total + (emp.add_price || 0), 0)
          this.payableAmount = Math.max(this.addPrice - this.creditAmount, 0)
        }
      } catch (error) {
        console.error('计算保费失败:', error)
      }
    },
    
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    validateEmployee(employee) {
      // 验证员工信息
      if (!employee.name || !employee.idcard) return
      
      // 这里可以添加身份证验证逻辑
      console.log('验证员工信息:', employee)
    },
    
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || 
                     file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
        return false
      }
      return true
    },
    
    handleUploadSuccess(response, file) {
      if (response && response.err_code === 0) {
        // 处理Excel文件解析
        this.parseExcelFile(file)
      }
    },
    
    parseExcelFile(file) {
      // 这里应该解析Excel文件并更新addEmployees
      // 暂时使用示例数据
      console.log('解析Excel文件:', file)
    },
    
    handlePaymentUploadSuccess(response) {
      if (response && response.err_code === 0) {
        this.paymentReceiptsUrl.push(response.data)
      }
    },
    
    handleCorrectUploadSuccess(response) {
      if (response && response.err_code === 0) {
        this.correctUrl.push(response.data)
      }
    },
    
    async submitAddEmployees(type) {
      // type: 1-保存草稿, 2-提交订单
      if (!this.addPrice) {
        this.$message.error('请先操作计算保费后，再提交订单')
        return
      }
      
      if (!this.validateAddEmployees()) {
        return
      }
      
      this.submitLoading = true
      this.btnDisabled = true
      
      try {
        const data = {
          order_id: this.currentRow.id,
          pay_type: this.payType,
          employee_list: this.addEmployees.map(emp => ({
            ...emp,
            add_price: Math.round(emp.add_price * 10000)
          })),
          effect_date: Math.floor(new Date(this.effectDate).getTime() / 1000),
          add_price: Math.round(this.addPrice * 100)
        }
        
        // 根据支付方式添加相应的文件
        if (this.payType === 1 && this.paymentReceiptsUrl.length > 0) {
          data.pay_voucher_url = this.paymentReceiptsUrl
        }
        
        if (this.correctUrl.length > 0) {
          data.correct_url = this.correctUrl
        }
        
        let response
        
        // 根据type参数调用不同的接口
        if (type === 1) {
          // 暂存草稿
          response = await ygbOrderAddEmployeeTemp(data)
        } else {
          // 正式提交
          response = await ygbOrderAddEmployee(data)
        }
        
        if (response && response.err_code === 0) {
          const successMsg = type === 1 ? '暂存成功' : '提交成功'
          this.$message.success(successMsg)
          this.$emit('success')
          this.handleClose()
        } else {
          const errorMsg = type === 1 ? '暂存失败' : '提交失败'
          this.$message.error(response.err_msg || errorMsg)
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('提交失败')
      } finally {
        this.submitLoading = false
        this.btnDisabled = true
      }
    },
    
    validateAddEmployees() {
      for (let i = 0; i < this.addEmployees.length; i++) {
        const emp = this.addEmployees[i]
        if (!emp.name) {
          this.$message.error('请完善人员姓名')
          return false
        }
        if (!emp.idcard) {
          this.$message.error('请完善人员身份证号')
          return false
        }
        // 这里可以添加更多验证逻辑
      }
      return true
    },
    
    // 计算参考保费
    async calculateReferencePremium() {
      // 1. 校验生效时间
      if (!this.effectDate) {
        this.$message.error('请先选择生效时间')
        return
      }
      
      // 2. 校验生效时间不能是过去的日期
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const effectDate = new Date(this.effectDate)
      effectDate.setHours(0, 0, 0, 0)
      
      if (effectDate < today) {
        this.$message.error('生效时间不能早于今天')
        return
      }
      
      // 3. 校验订单ID
      if (!this.currentRow || !this.currentRow.id) {
        this.$message.error('订单信息不完整，无法计算保费')
        return
      }
      
      // 4. 校验是否有加保员工信息
      if (!this.addEmployees || this.addEmployees.length === 0) {
        this.$message.error('请先添加员工信息')
        return
      }
      
      // 5. 校验加保员工信息是否完整
      const hasValidEmployee = this.addEmployees.some(emp => 
        emp.name && emp.name.trim() && 
        emp.idcard && emp.idcard.trim() && 
        emp.type
      )
      
      if (!hasValidEmployee) {
        this.$message.error('请先完善员工信息（姓名、身份证号、工作类型）')
        return
      }
      
      try {
        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '正在计算参考保费...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        const response = await ygbOrderAddPerPrice({
          order_id: this.currentRow.id,
          effect_date: this.formatDate(this.effectDate)
        })
        
        loading.close()
        
        if (response && response.err_code === 0) {
          // 校验返回的数据
          if (!response.data) {
            this.$message.error('服务器返回数据异常')
            return
          }
          
          this.cPrice = response.data.cPrice / 10000
          this.dPrice = response.data.dPrice / 10000
          this.tPrice = response.data.tPrice / 10000
          
          // 校验计算结果
          if (this.cPrice <= 0 && this.dPrice <= 0 && this.tPrice <= 0) {
            this.$message.warning('计算完成，但所有工作类型的保费均为0，请检查保险配置')
          } else {
            this.$message.success('参考保费计算完成')
          }
          
          // 自动更新员工的参考保费
          this.updateEmployeePremium()
          
        } else {
          this.$message.error(response.err_msg || '计算参考保费失败')
        }
      } catch (error) {
        console.error('计算参考保费失败:', error)
        this.$message.error('网络异常，计算参考保费失败')
      }
    },
    
    // 更新员工的参考保费
    updateEmployeePremium() {
      this.addEmployees.forEach(employee => {
        if (employee.type === 1) {
          employee.add_price = this.dPrice
        } else if (employee.type === 4) {
          employee.add_price = this.tPrice
        } else if (employee.type === 2) {
          employee.add_price = this.cPrice
        }
      })
      
      // 重新计算总保费
      this.calculatePremium()
    },
    handleSubstituteSuccess() {
      this.$emit('success')
      this.handleClose()
    },
    handleSubstituteCancel() {
      this.activeTab = 'edit'
    },
    
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.resetData()
    },
    
    resetData() {
      this.activeTab = 'edit'
      this.employees = []
      this.addEmployees = [{
        name: '',
        idcard: '',
        type: 1,
        add_price: 0
      }]
      this.effectDate = ''
      this.addPrice = 0
      this.payableAmount = 0
      this.paymentReceiptsUrl = []
      this.correctUrl = []
    }
  }
}
</script>

<style lang="less" scoped>
.edit-order-dialog {
  /deep/ .el-dialog {
    margin-top: 5vh !important;
  }
  
  /deep/ .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
  }
  
  .edit-section, .add-section {
    .order-info {
      margin-bottom: 20px;
      padding: 15px;
      background: #f5f5f5;
      border-radius: 4px;
    }
    
    .employee-table, .add-employee-table {
      margin-bottom: 20px;
      
      h3 {
        margin-bottom: 10px;
        color: #333;
        font-size: 16px;
        font-weight: bold;
      }
    }
    
    .table-actions {
      margin-top: 10px;
      text-align: left;
    }
    
    .premium-section {
      margin: 20px 0;
      padding: 15px;
      background: #f9f9f9;
      border-radius: 4px;
      
      .premium-text {
        font-weight: bold;
        color: #e6a23c;
      }
      
      // 增加行间距，避免日期选择器遮挡
      .el-row {
        margin-bottom: 20px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
      
      // 调整日期选择器的z-index
      .el-date-editor {
        position: relative;
        z-index: 1;
      }
    }
    
    .upload-section {
      margin: 20px 0;
      
      .upload-tips {
        display: inline-block;
        margin-left: 10px;
        vertical-align: top;
        
        .el-upload__tip {
          color: #999;
          font-size: 12px;
          margin-bottom: 5px;
        }
        
        .template-download {
          a {
            font-size: 12px;
            text-decoration: none;
            
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
    
    .file-upload-section {
      margin: 20px 0;
      
      .template-download {
        margin-top: 10px;
      }
    }
    
    .calculate-section {
      margin: 20px 0;
    }
    
    .reference-premium-table {
      table {
        border: 1px solid #ddd;
        
        td {
          border: 1px solid #ddd;
          font-size: 14px;
        }
      }
    }
    
    .special-tips {
      background: #fff7e6;
      border: 1px solid #ffd591;
      border-radius: 4px;
      padding: 15px;
      
      p {
        margin: 8px 0;
        line-height: 1.6;
        font-size: 14px;
        
        &:first-child {
          margin-top: 0;
        }
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    
    .action-buttons, .submit-section {
      text-align: center;
      margin-top: 20px;
      
      .el-button {
        margin: 0 10px;
      }
    }
  }
  
  // 表格样式调整
  /deep/ .el-table {
    .el-input {
      .el-input__inner {
        padding: 0 8px;
        height: 28px;
        line-height: 28px;
      }
    }
    
    .el-radio-group {
      .el-radio {
        margin-right: 15px;
        
        .el-radio__label {
          font-size: 12px;
        }
      }
    }
  }
  
  // 表单样式调整
  /deep/ .el-form {
    .el-form-item {
      margin-bottom: 15px;
      
      .el-form-item__label {
        font-size: 14px;
        color: #333;
      }
      
      .el-input {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
      
      .el-date-editor {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  
  // 上传组件样式
  /deep/ .el-upload {
    .el-button {
      height: 32px;
      padding: 8px 15px;
      font-size: 14px;
    }
  }
}
</style>
